import { render, staticRenderFns } from "./SponsorUploader.vue?vue&type=template&id=10154e5f&scoped=true"
import script from "./SponsorUploader.vue?vue&type=script&lang=js"
export * from "./SponsorUploader.vue?vue&type=script&lang=js"
import style0 from "./SponsorUploader.vue?vue&type=style&index=0&id=10154e5f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10154e5f",
  null
  
)

export default component.exports